import {attributeStructure} from 'components/organisms/players-csv/attributes-map-factory';

class CsvDataCreator {
    private readonly headAttributes: string[] = [];
    private readonly getPropValues: ((player) => any)[] = [];
    constructor(attributes: attributeStructure[]) {
        attributes.map((attribute) => {
            this.headAttributes.push(attribute.headAttributeName);
            this.getPropValues.push(attribute.getPlayerPropValue);
        });
    }
    createCsvData(players: object[]): any[][] {
        const csvData = [this.headAttributes];

        players.map((player) => {
            const rowData = this.getPropValues.map((getPropValue) => getPropValue(player));
            csvData.push(rowData);
        });

        return csvData;
    }
}

export default CsvDataCreator;
